// extracted by mini-css-extract-plugin
export default {"explanation":"Landing_explanation__AM14X","title":"Landing_title__XiBw6"};